<div><a target="_blank" rel="noopener noreferrer" href="{{ url }}">
    <mat-icon class="social-icon" svgIcon="{{ logo }}"></mat-icon></a>
</div>